"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tail = void 0;

/**
 * Get right most element of array
 *
 * @param  {Array}  source  The source
 *
 * @return {mixed}
 *
 * @tag Array
 * @signature (source: Array): mixed
 *
 * @example
 * tail([1, 2, 3])
 * // => 3
 * tail([])
 * // => undefined
 */
var tail = function tail(source) {
  return (Array.isArray(source) || typeof source === "string") && source.length !== 0 ? source[source.length - 1] : undefined;
};

exports.tail = tail;